export class RbacRolesConstant {
  /**
   * Roles
   */
  public static ADMIN = 1;
  public static AFFILIATE = 2;
  public static AFFILIATE_MANAGER = 'Scopes\\AffiliateManagerPermission';
}
